import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Paper, Typography, FormControl, InputLabel, Select,
    FormHelperText, Input, InputAdornment, Tooltip, Button,
    TextField, NativeSelect, InputBase, MenuItem,
    FormControlLabel, Checkbox, Grid } from '@material-ui/core';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: 'inherit',
        width: '100%',
        flexGrow: 1,
        color: '#2c91c7',
    },
    list: {
        width: 250,
    },
      fullList: {
        width: 'auto',
    },
    paper: {
        minWidth: 240,
        margin: '15px',
        padding: '10px',
        textAlign: 'left',
        backgroundColor: '#6c757d',
        //border: '2px solid #3f51b5',
        boxShadow: theme.shadows[5],
        //padding: theme.spacing(2, 4, 3),
        color: '#a3de9e',
    },
   
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }

const Home = (props) => {
    const classes = useStyles();

    const [pageContent, setPageContent] = useState('')

    // var client_id = '0cc8cbae575e44e6a19c24cbae8549e0'; // Your client id
    // var client_secret = '99ef44f233e64a4ebc064d8bc6520578'; // Your secret
    // var redirect_uri = 'http://localhost:3000/marketplace'; // Your redirect uri

    // let proxyServerUrl = 'https://sheltered-gorge-36130.herokuapp.com/';
    // let authUrl = `${proxyServerUrl}https://accounts.spotify.com/authorize?client_id=${client_id}&response_type=code
    //                 &redirect_uri=https%3A%2F%2Flocalhost:3000%2Fcallback&scope=user-read-private%20user-read-email`;

    // let content    

    // const AuthorizeUser = async () => {
    //     fetch(`https://sheltered-gorge-36130.herokuapp.com/https://accounts.spotify.com/authorize?
    //             response_type=code&client_id=${client_id}&redirect_uri=${encodeURIComponent(redirect_uri)}`)
    //         .then((response) => { 
    //             let data = response.text();
    //             setPageContent(data);      
    //             return data;
    //         });
    // }


    return (
        
        <div className={classes.root}>
            <Grid container xs={12} style={{ padding: '15px' }}>
                <Grid item xs={12}>
                    <h2>RaWCipH3R Networks</h2>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Paper className={classes.paper}>
                        <Typography>
                            Welcome to the future of discovery, money and a new streaming platform with ties to crypto,  latest technology innovations and management.
                        </Typography>
                        <Typography>
                        As peers, one can get a dividend for watching videos and music. With RC Token. Each media viewing has a set number of RC token one will receive.
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Paper className={classes.paper}>
                        <Typography>
                            Give the world and our children a brighter future, to be paid, as billions of people do a day, which is simply using the internet.
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <h5>RaWCipH3R &copy; {new Date().getFullYear()}</h5>
                </Grid>


            </Grid>
        </div>
    )
}

export default Home;